import React from 'react';
import { useQuery } from '@apollo/client';
import { Appearance } from '@atlaskit/section-message';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { fetchInflightInvoiceForInvoiceGroup } from './queries/fetch-inflight-invoice';
import { withApollo } from '../graphql-provider';
import { InfoPanel } from '../index';
import './inflight-invoice-banner.scss';

export interface InflightInvoiceBannerForInvoiceGroupProps {
  invoiceGroupId: string;
  message: string;
  type?: Appearance;
}

export const InflightInvoiceBannerForInvoiceGroup: React.FC<InflightInvoiceBannerForInvoiceGroupProps> = ({
  invoiceGroupId,
  message,
  type = 'warning',
}) => {
  const { data, loading } = useQuery<
    generatedTypesNew.FetchInflightInvoiceForInvoiceGroupQuery,
    generatedTypesNew.FetchInflightInvoiceForInvoiceGroupQueryVariables
  >(fetchInflightInvoiceForInvoiceGroup, {
    variables: { id: invoiceGroupId },
    fetchPolicy: 'cache-and-network',
    displayName: 'fetchInflightInvoice',
    skip: !invoiceGroupId,
  });

  if (loading) return null;

  const hasPendingInvoices = data?.invoiceGroup?.pendingInvoices && data?.invoiceGroup?.pendingInvoices?.length > 0;

  return (
    <div className="inflight-invoice-banner">{hasPendingInvoices && <InfoPanel type={type} message={message} />}</div>
  );
};

export default withApollo(InflightInvoiceBannerForInvoiceGroup);
